import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { range } from "ramda";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Clear";
import PrintIcon from "@mui/icons-material/Print";

import EclipseLoader from "~/components/EclipseLoader";
import InlineToolbar from "~/components/InlineToolbar";
import clsx from "clsx";

const Header = styled(DialogTitle)(() => ({
  position: "relative",
  margin: 0,
  padding: 0,
  display: "flex",
  alignItems: "center"
}));

const Title = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  marginLeft: 0,
  marginRight: "auto"
}));

function loadImage(path) {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.addEventListener("load", () => {
      resolve(image);
    });

    image.addEventListener("error", error => {
      reject(error);
    });

    image.src = path;
  });
}

function loadImages(paths) {
  return Promise.all(paths.map(loadImage));
}

function PrintAllPagesStaticModal({ hideModal, additionalProps, kind, ...props }) {
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { material, DLS } = additionalProps;
  const { pagesCount } = material;
  const pages = range(1, pagesCount + 1);
  const paths = pages.map(page => DLS.getImagePath(page, 1.5));

  function onPrint() {
    // window.onPrintRequestStart("teacher");
    // window.issueGlobalPrint(paths, "teacher");
  }

  // useEffect(() => {

  //   window.issueGlobalPrint(paths);

  //   // setIsLoading(true);
  //   // loadImages(paths)
  //   //   .then(setImages)
  //   //   .then(() => setIsLoading(false))
  //   //   .catch(() => setIsLoading(false))
  //     // .catch(console.error);
  // }, [DLS, pagesCount]);

  return (
    <>
      <Header className="dialog-title">
        <Title variant="h6" id={`${kind}-modal-title`}>
          Druckvorschau: {material.name}
        </Title>

        <InlineToolbar onClick={onPrint}>
          <IconButton disabled={isLoading} size="large" aria-label="Drucken">
            <PrintIcon />
          </IconButton>
        </InlineToolbar>

        <InlineToolbar>
          <IconButton onClick={hideModal} size="large" aria-label="Schließen">
            <CloseIcon />
          </IconButton>
        </InlineToolbar>
      </Header>
      <DialogContent>
        <div className={clsx(["viewer", "viewer--teacher"])}>
          {isLoading ? (
            <EclipseLoader color="gray" />
          ) : (
            images.map((image, index) => <img key={`lazy_static_${index}`} alt="" src={image.src} />)
          )}
        </div>
      </DialogContent>
    </>
  );
}

PrintAllPagesStaticModal.propTypes = {
  hideModal: PropTypes.func,
  additionalProps: PropTypes.object,
  kind: PropTypes.string
};

export default PrintAllPagesStaticModal;
